<template>
  <div>
    <div class="max-w-5xl mx-auto my-10">
      <osv-cart-product />
    </div>
  </div>
</template>

<script>
import { ALBIGNY_CONFIG } from "../../assets/allosv.config";
export default {
  mounted() {
    window.__osvConf = ALBIGNY_CONFIG;
  }
};
</script>

<style lang="scss" scoped>
.product-link {
    @apply text-white font-bold text-base px-4 py-2 rounded shadow whitespace-nowrap;
    &.alb {
        background-color: $alb;
    }
    &.stefoy {
        background-color: $stefoy;
    }
}
</style>
